/* globals self */
const fetchModule = self.fetch.bind(self)
module.exports = fetchModule
module.exports.default = module.exports
